import React, { useEffect, useCallback, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import useClickOutside from '../../../../common/hooks/useClickOutside';
import { useSelector, useDispatch } from 'react-redux';
import { getDocAssigment, returnPdf } from '../../../services/documentsService';
import { RootState } from '../../../../redux/store';
import { PDF, POPUP } from '../../../../redux/types';

import { IDocument } from '../../types/IDocument';
import { IFile } from '../../types/IFile';

import PdfViewer from '../pdfViewer/pdfViewer';
import Icon from '../../../ui/icon/icon';

import './pdfDialog.scss';

const modalElement = document.getElementById('modal-root');

export const PdfDialog: React.FC = () => {
  const [file, setFile] = useState<IFile>({ uint8: '', blob: '' });
  const [pdfDocument, setPdfDocument] = useState<IDocument>({ label: '' });
  const [loading, setLoading] = useState<boolean>(true);

  const dispatch = useDispatch();
  const dialogRef = useRef(null);

  const showDialog = useSelector((state: RootState) => state.pdf.showDialog);
  const assignId = useSelector((state: RootState) => state.pdf.assignId);

  const close = () => {
    dispatch({ type: PDF.HIDE_PDF_DIALOG });
  };

  const handleEscape = useCallback(
    (event) => {
      if (event.keyCode === 27) close();
    },
    [close],
  );

  useEffect(() => {
    if (assignId) {
      setLoading(true);
      getDocAssigment(parseInt(assignId))
        .then((res) => {
          returnPdf(`/Documents/Download/${res.data.documentId}`)
            .then((e: any) => {
              setFile(e);
              setLoading(false);
            })
            .catch((err) => {
              dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message });
              setLoading(false);
            });
          setPdfDocument(res.data);
        })
        .catch((err) => {
          dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message });
          setLoading(false);
        });
    }
  }, [assignId]);

  useEffect(() => {
    if (showDialog) document.addEventListener('keydown', handleEscape, false);
    return () => {
      document.removeEventListener('keydown', handleEscape, false);
    };
  }, [handleEscape, showDialog]);

  useClickOutside(dialogRef, close);

  return createPortal(
    showDialog ? (
      <div className={'pdf-dialog-overlay-wrapper'}>
        <div className='pdf-dialog-body' ref={dialogRef}>
          <div className={'pdf-dialog-title'}>
            <span className='pdf-title-text'>{pdfDocument.label}</span>
            <Icon name='fas fa-xmark' className='impersonate-off-icon pointer' onClick={close} />
          </div>
          <PdfViewer
            shouldPin={true}
            id={assignId}
            loading={loading}
            file={file}
            returnPath={'/documents'}
            document={pdfDocument}
            title={false}
            onClose={close}
            controlsBcgColor={'$mainBg'}
          />
        </div>
      </div>
    ) : null,
    modalElement,
  );
};

export default PdfDialog;